export type WarningProps = {
  size?: number;
  color?: string;
};

const Warning = ({ size, color }: WarningProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3771_5187)">
      <path
        d="M7.99984 12C8.18393 12 8.33317 11.8507 8.33317 11.6666C8.33317 11.4826 8.18393 11.3333 7.99984 11.3333C7.81574 11.3333 7.6665 11.4826 7.6665 11.6666C7.6665 11.8507 7.81574 12 7.99984 12Z"
        fill={color}
      />
      <path
        d="M7.99984 15.3333C12.0499 15.3333 15.3332 12.0501 15.3332 7.99999C15.3332 3.9499 12.0499 0.666656 7.99984 0.666656C3.94975 0.666656 0.666504 3.9499 0.666504 7.99999C0.666504 12.0501 3.94975 15.3333 7.99984 15.3333Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 4V9.33333"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99984 12C8.18393 12 8.33317 11.8507 8.33317 11.6666C8.33317 11.4826 8.18393 11.3333 7.99984 11.3333C7.81574 11.3333 7.6665 11.4826 7.6665 11.6666C7.6665 11.8507 7.81574 12 7.99984 12Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3771_5187">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default Warning;
